// import Vue from 'vue'
import TrackService from '@/assets/services/TrackService'
import SubscribeService from '@/assets/services/SubscribeService'
import { setCookie } from '@/assets/helpers/UtilHelper'

const TOGGLE_PLAYER_DISPLAY = 'TOGGLE_PLAYER_DISPLAY'
const TOGGLE_PLAYER_PANEL = 'TOGGLE_PLAYER_PANEL'
const TOGGLE_PLAYER_RANDOM = 'TOGGLE_PLAYER_RANDOM'
const TOGGLE_PLAYER_PAUSED = 'TOGGLE_PLAYER_PAUSED'

const SET_PLAYER_INDEX = 'SET_PLAYER_INDEX'
const SET_PLAYER_VOLUME = 'SET_PLAYER_VOLUME'
const SET_REPEAT = 'SET_REPEAT'
const UPDATE_LOADING = 'UPDATE_LOADING'
const UPDATE_PLAYER_INFO = 'UPDATE_PLAYER_INFO'
const RESET_QUEUE = 'RESET_QUEUE'
const SET_PLAYLIST_TO_QUEUE = 'SET_PLAYLIST_TO_QUEUE'
const SET_TRACKLIST_TO_POOL = 'SET_TRACKLIST_TO_POOL'
const SET_TRACK_TO_QUEUE = 'SET_TRACK_TO_QUEUE'
const REMOVE_TRACK_FROM_QUEUE = 'REMOVE_TRACK_FROM_QUEUE'

const RANDOM_NUM = 3
const RANDOM_POOL = 'RANDOM_POOL'
const RANDOM_NEXT = 'RANDOM_NEXT'
const RANDOM_POOL_UPDATE = 'RANDOM_POOL_UPDATE'
const RANDOM_POOL_SHIFT = 'RANDOM_POOL_SHIFT'
const RANDOM_POOL_RESET = 'RANDOM_POOL_RESET'

const PGNNP_AUDIO_NUM = 1
const PGNNP_AUDIO_NEXT = 'PGNNP_AUDIO_NEXT'
const PGNNP_AUDIO_MODE = 'PGNNP_AUDIO_MODE'
const PGNNP_AUDIO_MASK = 'PGNNP_AUDIO_MASK'
const PGNNP_AUDIO_ENDED = 'PGNNP_AUDIO_ENDED'
const SET_PGNNP_AUDIO_INFO = 'SET_PGNNP_AUDIO_INFO'
const SET_TO_PREPEND = 'SET_TO_PREPEND'
const SET_PLAYING_COUNT = 'SET_PLAYING_COUNT'
const CHECK_IS_ANY_ADS = 'CHECK_IS_ANY_ADS'
const INCREASE_PLAYING_COUNT = 'INCREASE_PLAYING_COUNT'

const state = {
  initialClick: false,
  display: false, // show player
  panel: false, // show player control panel
  random: false,
  src: '',
  currentTime: 0,
  duration: 0,
  paused: true,
  ended: false,
  volume: 0.6,
  repeat: 0,
  index: 0,
  queue: [], // for play
  pool: [], // for random
  trackId: '', // current index
  track: {}, // current track,
  loading: false,
  pgnnpAudio: {},
  pgnnpAudioMask: false,
  pgnnpAudioMode: false,
  isPrependToPool: false,
  isAnyPgnnpAudio: true,
  playingCount: 0,
  playingInterval: 65535
}

const getters = {
  display: state => state.display,
  panel: state => state.panel,
  random: state => state.random,
  getPlayerPaused: state => state.paused,
  getPlayerIndex: state => state.index,
  getPlayerQueue: state => state.queue,
  getCurrentTrack: state => state.queue[state.index]
}

const mutations = {
  [TOGGLE_PLAYER_DISPLAY]: (state, data) => {
    state.display = typeof (data) === 'boolean' ? data : !state.display
  },
  [TOGGLE_PLAYER_PANEL]: (state, data) => {
    state.panel = typeof (data) === 'boolean' ? data : !state.panel
  },
  [TOGGLE_PLAYER_RANDOM]: (state, data) => {
    state.random = typeof (data) === 'boolean' ? data : !state.random
  },
  [TOGGLE_PLAYER_PAUSED]: (state, data) => {
    state.paused = typeof (data) === 'boolean' ? data : !state.paused
    if (!state.initialClick) {
      state.initialClick = true
    }
  },
  [SET_PLAYER_INDEX]: (state, data) => {
    state.index = data
    state.track = state.queue[state.index] ? state.queue[state.index] : {}
    state.trackId = state.queue[state.index] ? state.queue[state.index].id : ''
  },
  [SET_PLAYER_VOLUME]: (state, data) => {
    state.volume = data
  },
  [SET_REPEAT]: (state, data) => {
    state.repeat = data
  },
  [UPDATE_PLAYER_INFO]: (state, data) => {
    state.src = data.src
    // state.paused = data.paused
    state.ended = data.ended
    state.currentSrc = data.currentSrc
    // state.autoplay = data.autoplay
    // state.controls = data.controls
    // state.seeking = data.seeking
    // state.loop = data.loop
    state.volume = data.volume
    state.muted = data.muted
    state.defaultMuted = data.defaultMuted
    state.currentTime = data.currentTime
    state.duration = data.duration
  },
  [RESET_QUEUE]: (state) => {
    state.queue = []
    state.track = {}
    state.trackId = ''
    state.currentTime = 0
    state.duration = 0
    state.index = 0
  },
  [SET_PLAYLIST_TO_QUEUE]: (state, data) => {
    state.queue = state.queue.concat(data)
  },
  [SET_TRACKLIST_TO_POOL]: (state, data) => {
    if (state.isPrependToPool) {
      state.pool.unshift(state.track)
      state.pool.unshift(data[0])
      state.isPrependToPool = false
    } else {
      state.pool = data
    }
  },
  [SET_TRACK_TO_QUEUE]: (state, data) => {
    if (state.queue.length === 0 && state.index === 0) {
      state.queue.push(data)
    } else if (state.queue.length > 0) {
      state.queue.splice(state.index + 1, 0, data)
    }
  },
  [REMOVE_TRACK_FROM_QUEUE]: (state, index) => {
    if (state.queue.length > 0) {
      state.queue.splice(index, 1)
    }
  },
  [RANDOM_POOL_UPDATE]: (state) => {
    if (state.pool[0]) {
      state.track = state.pool[0]
      state.trackId = state.pool[0].id
      state.pool.shift()
    } else {
      state.track = {}
      state.trackId = ''
    }
  },
  [RANDOM_POOL_SHIFT]: (state) => {
    state.pool.shift()
  },
  [RANDOM_POOL_RESET]: (state) => {
    state.pool = []
  },
  [UPDATE_LOADING]: (state, data) => {
    state.loading = data
  },
  [PGNNP_AUDIO_MODE]: (state, data) => {
    state.pgnnpAudioMode = data
  },
  [PGNNP_AUDIO_MASK]: (state, data) => {
    state.pgnnpAudioMask = data
  },
  [PGNNP_AUDIO_ENDED]: (state, data) => {
    // state.pgnnpAudioMask = data
  },
  [SET_PGNNP_AUDIO_INFO]: (state, data) => {
    state.pgnnpAudio = data
  },
  [SET_TO_PREPEND]: (state, data) => {
    state.isPrependToPool = data
  },
  [SET_PLAYING_COUNT]: (state, data) => {
    state.playingCount = data
  },
  [CHECK_IS_ANY_ADS]: (state, data) => {
    state.isAnyPgnnpAudio = data
  },
  [INCREASE_PLAYING_COUNT]: (state, commit, data) => {
  }
}

const actions = {
  [RANDOM_POOL]: async ({ state, commit }, params) => {
    const count = RANDOM_NUM
    const randomTrackList = await TrackService.getTracksByRandom(count)
    commit('SET_TRACKLIST_TO_POOL', randomTrackList)
    commit('RANDOM_POOL_UPDATE')
    return randomTrackList
  },
  [RANDOM_NEXT]: async ({ state, commit }, params) => {
    if (state.pool.length < 1) {
      const randomPlaylist = await TrackService.getTracksByRandom(RANDOM_NUM)
      if (randomPlaylist) {
        commit('SET_TRACKLIST_TO_POOL', randomPlaylist)
        commit('RANDOM_POOL_UPDATE')
      } else {
        // console.error('Get tracks by random failed...')
      }
    } else {
      commit('RANDOM_POOL_UPDATE')
    }
  },
  [PGNNP_AUDIO_NEXT]: async ({ dispatch, state, commit }, params) => {
    const pgnnpAudio = await window.PgnnpSDK.getAudioAds(PGNNP_AUDIO_NUM)
    const token = window.localStorage.getItem(process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY)
    const subscriptionStatus = token ? await SubscribeService.getSubscription(token) : null
    const isSubscribe = subscriptionStatus !== null && subscriptionStatus.subscription.length > 0
    // const pgnnpAudio = [] // disable pgnnp audio
    commit('CHECK_IS_ANY_ADS', pgnnpAudio.length > 0)
    if (pgnnpAudio && pgnnpAudio.length && !isSubscribe && state.playingCount > 0) { // && !pgnnpAudio.err
      let audioAd = [{
        duration: pgnnpAudio[0].audio[0].duration,
        file_link: pgnnpAudio[0].audio[0].url,
        id: pgnnpAudio[0].session,
        movement: {
          work: {
            people: {
              langs: [{
                last_name: pgnnpAudio[0].title_major,
                locale: 'en-us'
              }, {
                last_name: pgnnpAudio[0].title_major,
                locale: 'zh-tw'
              }]
            },
            langs: []
          },
          langs: []
        },
        performers: [{
          people: {
            langs: [{
              last_name: pgnnpAudio[0].title_minor,
              locale: 'en-us'
            }, {
              last_name: pgnnpAudio[0].title_minor,
              locale: 'zh-tw'
            }]
          }
        }]
      }]
      commit('PGNNP_AUDIO_MODE', true)
      commit('PGNNP_AUDIO_MASK', true)
      commit('TOGGLE_PLAYER_PANEL', false)
      commit('SET_TRACKLIST_TO_POOL', audioAd)
      commit('SET_PGNNP_AUDIO_INFO', pgnnpAudio[0])
      commit('RANDOM_POOL_UPDATE')
    } else {
      commit('PGNNP_AUDIO_MODE', false)
      if (state.random) {
        if (pgnnpAudio.length === 0 && state.playingCount === 0) {
          // console.log('No pgnnpAudio', state.index)
        } else {
          dispatch('RANDOM_NEXT')
        }
      } else {
        if (state.index + 1 > state.queue.length) {
          commit('SET_PLAYER_INDEX', 0)
          commit('TOGGLE_PLAYER_PAUSED', true)
        } else if (pgnnpAudio.length === 0 && state.index === 0) {
          commit('SET_PLAYER_INDEX', state.index)
        } else if (state.playingCount === 0) {
          const count = state.playingCount + 1
          commit('SET_PLAYING_COUNT', count)
          commit('SET_PLAYER_INDEX', state.index)
          setCookie('player_play_count', count)
        } else {
          commit('SET_PLAYER_INDEX', state.index + 1)
        }
      }
    }
  },
  [PGNNP_AUDIO_ENDED]: async ({ state, commit }, params) => {
    const pgnnpAudioEnded = await window.PgnnpSDK.sendAudioAdListened(state.pgnnpAudio.session)
    if (pgnnpAudioEnded) {
      // console.log('PGNNP_AUDIO_ENDED')
    }
  },
  [INCREASE_PLAYING_COUNT]: async ({ dispatch, state, commit }, params) => {
    const count = state.playingCount + 1
    commit('SET_PLAYING_COUNT', count)
    setCookie('player_play_count', count)

    if ((state.playingCount % state.playingInterval === 0)) {
      dispatch('PGNNP_AUDIO_NEXT')
      commit('TOGGLE_PLAYER_PAUSED', false)
      if (!state.isAnyPgnnpAudio) {
        document.querySelector('#audioPlayer').play()
        document.querySelector('#audioPlayer').pause()
      }
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
